import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const a = i((r, s) => /* @__PURE__ */ o.jsx(
  t,
  {
    ref: s,
    ...r,
    image: (e) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...e,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M4.5 7.134a1 1 0 0 0 0 1.732l9 5.196a1 1 0 0 0 1.5-.866V2.804a1 1 0 0 0-1.5-.866zM3 2v12H1V2z"
          }
        )
      }
    )
  }
));
a.displayName = "PreviousIcon";
export {
  a as PreviousIcon,
  a as default
};
//# sourceMappingURL=index.js.map
